<template>
  <div>
    
    <div v-if="shiftStore.data[location].shifts.length === 0" v-on:click="shiftStore.loadData(location, numOfShifts)">
      <br />
      Loading {{location}} Shifts...

    </div>
    <div v-else>
      <!-- <BasicTableComponent :list="data" :hideColumns="['RowID']">
        <div slot="header">{{location}}</div>
      </BasicTableComponent> -->
      <h3>{{location}}</h3>
      <table>
        <thead>
          <tr>
            <th v-for='key in ["Day", "Start","End", "Shift","NetSalesTaxed","NetSalesNonTaxed"]' :key="key" align="center">
              {{key}}
            </th>
            
            <th v-if="showDataEntry" align="center">Cashier</th>
            <th v-if="showDataEntry" align="center">Safe</th>
            <th v-if="showDataEntry" align="center">Coin</th>
            <th v-if="showDataEntry" align="center">BU POS</th>
            <th v-if="showDataEntry" align="center">Charges</th>
            <th v-if="showDataEntry" align="center">Thefts</th>
            <th v-if="showDataEntry" align="center">POS Err</th>
            <th v-if="showDataEntry" align="center">Pre-pay Err</th>
            <th v-if="showDataEntry" align="center">Uncollected</th>
            <th v-if="showDataEntry" align="center">Misc Err</th>
            <!-- <th v-if="showDataEntry" align="center">P@P</th> -->
            <th align="center">O/S Calc</th>
            <th v-if="showDataEntry" align="center">Notes</th>


            <th align="center">O/S (ignore)</th>
            <th align="center">Cash</th>
            <th v-if="showTransCounts" align="center">#</th>
            <th align="center">Safe Drops</th>

            <th align="center">Debit</th>
            <th v-if="showTransCounts" align="center">#</th>
            <th align="center">Credit</th>
            <th v-if="showTransCounts" align="center">#</th>
            <th align="center">Cheque</th>
            <th v-if="showTransCounts" align="center">#</th>
            <th align="center">Gift Card</th>
            <th v-if="showTransCounts" align="center">#</th>
            
          </tr>
        </thead>
        <tbody>

          <tr v-for="(row, index) in shiftStore.shiftsWithTotals(location)" :key="index">
            <td v-for='key in ["day"]' :key="key" align="left">
              {{row[key] | DF("ddd MM/DD/YY")}}
            </td>
            <td v-for='key in ["StartDateTime"]' :key="key" align="left">
              {{row[key] | DF('ddd hh:mm a')}}
            </td>
            <td v-for='key in ["EndDateTime"]' :key="key" align="left">
              {{row[key] | DF('ddd hh:mm a')}}
            </td>
            <td align="right">
              {{row["IDUsed"] | cleanShift}}
            </td>
            <td v-for='key in ["NetSalesTaxed","NetSalesNonTaxed"]' :key="key" align="right">
              {{row[key] | NF}}
            </td>

            <!-- <td>{{row.shiftsJson}}</td> -->
            

            
            <td v-if="showDataEntry">
              <!-- <p>Cashier</p> -->
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.cashiers[0]" v-on:change="saveEdit(row)">
            </td>
            <td v-if="showDataEntry">
              <!-- <p>Safe</p> -->
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.safe" v-on:change="saveEdit(row)">
            </td>
            <td v-if="showDataEntry">
              <!-- <p>Coin</p> -->
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.coin" v-on:change="saveEdit(row)">
            </td>
            <td v-if="showDataEntry">
              <!-- <p>BU POS</p> -->
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.backupTerminal" v-on:change="saveEdit(row)">
            </td>
            <td v-if="showDataEntry">
              <!-- <p>Deduct Charges</p> -->
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.deductions.charges" v-on:change="saveEdit(row)">
            </td>
            <td v-if="showDataEntry">
              <!-- <p>Deduct Thefts</p> -->
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.deductions.thefts" v-on:change="saveEdit(row)">
            </td>
            <td v-if="showDataEntry">
              <!-- <p>Deduct Errors</p> -->
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.deductions.pos_errors" v-on:change="saveEdit(row)">
            </td>
            <td v-if="showDataEntry">
              <!-- <p>Deduct Errors</p> -->
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.deductions.pre_pay_errors" v-on:change="saveEdit(row)">
            </td>
            <td v-if="showDataEntry">
              <!-- <p>Deduct Errors</p> -->
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.deductions.uncollected" v-on:change="saveEdit(row)">
            </td>
            <td v-if="showDataEntry">
              <!-- <p>Deduct Errors</p> -->
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.deductions.errors" v-on:change="saveEdit(row)">
            </td>
            <!-- <td v-if="showDataEntry">
              <input style="text-align: right;" size="6" v-model="row.shiftsJson.data.payAtPump" v-on:change="saveEdit(row)">
            </td> -->
            
            <td align="right">
              <!-- <p>O/S</p> -->
              {{overShort(row) | NF}}
              </td>

            <td v-if="showDataEntry">
              <textarea style="text-align: right;" size="6" v-model="row.shiftsJson.data.note" v-on:change="saveEdit(row)" />
            </td>
            <!-- </div> -->
            <!-- <td align="right"><input type="text" v-model="row.shiftsJson.data.cashiers[0]"></td> -->
            


            <td align="right">{{shiftsMediaTypeCountForKey(row,'Cash').OverShort | NF}}</td>

            <td align="right">{{shiftsMediaTypeForKey(row,'Cash').MediaTotal | NF}}</td>
            <td v-if="showTransCounts" align="right">{{shiftsMediaTypeForKey(row,'Cash').NumSales | NF('0,0')}}</td>
            <td align="right">{{shiftsMediaTypeForKey(row,'Cash').SafeDrops| NF}}</td>
            

            <td align="right">{{shiftsMediaTypeForKey(row,'Debit').MediaTotal | NF}}</td>
            <td v-if="showTransCounts" align="right">{{shiftsMediaTypeForKey(row,'Debit').NumSales | NF('0,0')}}</td>
            
            <td align="right">{{shiftsMediaTypeForKey(row,'Credit').MediaTotal | NF}}</td>
            <td v-if="showTransCounts" align="right">{{shiftsMediaTypeForKey(row,'Credit').NumSales | NF('0,0')}}</td>
            
            <td align="right">{{shiftsMediaTypeForKey(row,'Cheque').MediaTotal | NF}}</td>
            <td v-if="showTransCounts" align="right">{{shiftsMediaTypeForKey(row,'Cheque').NumSales | NF('0,0')}}</td>
            
            <td align="right">{{shiftsMediaTypeForKey(row,'Gift Card').MediaTotal | NF}}</td>
            <td v-if="showTransCounts" align="right">{{shiftsMediaTypeForKey(row,'Gift Card').NumSales | NF('0,0')}}</td>

            

          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import formatDataMixin from '@/mixins/formatDataMixin.js'

export default {
  name: 'Shift',
  mixins : [formatDataMixin],
  inject: ['shiftsPage'],
  props : ['location', 'showDataEntry', 'showTransCounts', 'numOfShifts'],
  data () { return { 
    data: []
    } 
  },
  watch : {
    numOfShifts: function(){
      this.shiftStore.debounceLoadData(this.location, this.numOfShifts)
    }
  },
  created () {
    this.shiftStore.loadData(this.location, this.numOfShifts)
  },
  methods:{
    
    saveEdit(row){
      this.shiftStore.saveEdit(this.location, row);
    },
    shiftsMediaTypeForKey(row, key){
      return this.shiftStore.shiftsMediaTypeForKey(row, key)
    },
    shiftsMediaTypeCountForKey(row, key){
      return this.shiftStore.shiftsMediaTypeCountForKey(row, key)
    },
    overShort(row){
      return this.shiftStore.overShort(row)
    }
  },
  filters: {
    cleanShift: function(val){
      return val.replace('1001', '')
    }
  },
  computed:{
    
    shiftStore(){
      return this.shiftsPage.$refs.shiftStore;
    },
    
  }
}
</script>